import api from "@/services/api";

class CreateTransactionSignature {
  execute = async (customerDocument: string) => {
    const payload = {
      customerDocument,
    };
    const response = await api().post("/transaction/signature", payload);
    return response.data;
  };
}

export { CreateTransactionSignature };



